"use client";

import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import { UFS_INFO, VIEWBOX } from "@/components/mapa/brasil-geo";

/* Painel Shoppub fiel às telas reais do produto: Geral, Mapa de
   Vendas, Fluxo de vendas, Pedidos e Curva ABC (Estoques e Vendas
   desabilitadas). Dados ilustrativos coerentes entre as abas;
   receita e total de pedidos vivos. */

const VERMELHO = "#f26d6d", AMARELO = "#f5b840", VERDE = "#79c56f", AZUL = "#4aa8e0";
const VERDE_SP = "#7cb342";
const REGIAO_COR: Record<string, string> = { N: "#66bb6a", NE: "#f26d6d", CO: "#2f9be4", SE: "#f0b429", S: "#a855f7" };
const PCT_UF: Record<string, string> = {
  AM: "1,4%", PA: "1,5%", MT: "1,4%", MS: "2,2%", GO: "3,1%", TO: "0,7%",
  MG: "7,9%", SP: "36,1%", BA: "5,2%", CE: "3,7%", MA: "0,8%", PI: "0,6%",
  PR: "6,4%", SC: "4,3%", RS: "5,1%", RO: "0,4%",
};

const ICONES: Record<string, string> = {
  grid: "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z",
  mapa: "M9 4L4 6v14l5-2 6 2 5-2V4l-5 2-6-2zM9 4v14M15 6v14",
  fluxo: "M12 8a3 3 0 100-6 3 3 0 000 6zM6 21c.5-4 2.8-6 6-6M15 15l3 3 4-4",
  cart: "M4 6h2l2.4 10h9.2L20 8H7M10 20a1 1 0 100-2 1 1 0 000 2zM17 20a1 1 0 100-2 1 1 0 000 2z",
  curva: "M4 18L10 12l3 3 7-7M14 8h6v6",
  caixa: "M4 8l8-4 8 4v8l-8 4-8-4zM4 8l8 4 8-4M12 12v8",
  vendas: "M4 20h16M6 16v-4M11 16V8M16 16v-6",
  sacola: "M6 7h12l1 13H5L6 7zM9 10V6a3 3 0 016 0v4",
  calendario: "M5 6h14v14H5zM5 10h14M9 4v4M15 4v4",
  pessoas: "M15 11a3 3 0 10-6 0 3 3 0 006 0zM5 21c.7-3.6 3.4-5.5 7-5.5s6.3 1.9 7 5.5",
  estrela: "M12 4l1.7 3.9 4.3.4-3.2 2.8 1 4.2-3.8-2.3-3.8 2.3 1-4.2L6 8.3l4.3-.4z",
  carrinho: "M8 6h13l-2 8H9L7 4H4M10 20a1 1 0 100-2 1 1 0 000 2zM17 20a1 1 0 100-2 1 1 0 000 2z",
  ticket: "M4 9a2 2 0 002-2h12a2 2 0 002 2v2a2 2 0 000 4v2a2 2 0 00-2 2H6a2 2 0 00-2-2v-2a2 2 0 000-4zM13 7v10",
  cadastro: "M8 4h9l3 3v13H8zM8 4v16M11 9h6M11 12h6M11 15h4",
  recorrente: "M12 8a3 3 0 100-6 3 3 0 000 6zM6 21c.5-4 2.8-6 6-6M17 14v3h3M17 17a4 4 0 104 4",
  pct: "M6 18L18 6M8 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM16 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
  caminhao: "M3 7h11v9H3zM14 10h4l3 3v3h-7zM7 19a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17 19a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
  cifrao: "M12 4v16M8.5 8.5c0-1.4 1.6-2.5 3.5-2.5s3.5 1.1 3.5 2.5-1.6 2.2-3.5 2.7-3.5 1.3-3.5 2.8 1.6 2.5 3.5 2.5 3.5-1.1 3.5-2.5",
  check: "M5 9h14v10H5zM5 9l2-4h10l2 4M9 14l2 2 4-4",
  monitor: "M4 5h16v11H4zM9 20h6M12 16v4",
  celular: "M8 3h8v18H8zM11 18h2",
  carteira: "M4 7h15a2 2 0 012 2v8a2 2 0 01-2 2H4zM4 7V5.5A1.5 1.5 0 015.5 4H17M16 13h3",
};

function Icone({ d, cls = "h-5 w-5", stroke = "#fff" }: { d: string; cls?: string; stroke?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={cls} fill="none" stroke={stroke} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d={ICONES[d]} />
    </svg>
  );
}

const ABAS = [
  { nome: "Geral", icone: "grid", viva: true },
  { nome: "Mapa de Vendas", icone: "mapa", viva: true },
  { nome: "Fluxo de vendas", icone: "fluxo", viva: true },
  { nome: "Pedidos", icone: "cart", viva: true },
  { nome: "Curva ABC", icone: "curva", viva: true },
  { nome: "Estoques", icone: "caixa", viva: false },
  { nome: "Vendas", icone: "vendas", viva: false },
];
const CICLO = [0, 1, 2, 3, 4];

function Delta({ v, sobe }: { v: string; sobe: boolean }) {
  return (
    <span className={`text-[11px] font-semibold ${sobe ? "text-[#2a7d30]" : "text-[#c62f2c]"}`}>
      {v} {sobe ? "↑" : "↓"}
    </span>
  );
}

function Kpi({ cor, icone, n, label, sub, delta, sobe }: {
  cor: string; icone: string; n: string; label: string; sub?: string; delta?: string; sobe?: boolean;
}) {
  return (
    <div className="relative flex items-center gap-3 rounded-lg bg-white p-3 shadow-[0_1px_4px_rgba(0,0,0,0.07)]">
      <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md" style={{ background: cor }}>
        <Icone d={icone} cls="h-5.5 w-5.5" />
      </span>
      <span className={`min-w-0 ${delta ? "sm:pr-9" : ""}`}>
        <span className="block font-display text-[15px] font-semibold leading-tight text-[#333] sm:text-lg">{n}</span>
        <span className="block text-[11px] leading-tight text-[#6f6f6f]">{label}</span>
        {sub && <span className="block text-[9px] leading-tight text-[#767676]">{sub}</span>}
        {delta && (
          <span className="mt-0.5 block sm:hidden">
            <Delta v={delta} sobe={!!sobe} />
          </span>
        )}
      </span>
      {delta && (
        <span className="absolute right-3 top-2.5 hidden sm:block">
          <Delta v={delta} sobe={!!sobe} />
        </span>
      )}
    </div>
  );
}

function Filtro({ icone, label }: { icone: string; label: string }) {
  return (
    <div className="flex items-center gap-3 rounded-lg bg-white px-4 py-3 shadow-[0_1px_4px_rgba(0,0,0,0.07)]">
      <Icone d={icone} cls="h-5 w-5" stroke="#555" />
      <span className="text-[13px] font-semibold tracking-wide text-[#444]">{label}</span>
      <span className="ml-auto text-[#7cb342]">▾</span>
    </div>
  );
}

const fmt = (v: number) =>
  v.toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2 });

/* curva cumulativa da ABC (concava): y = t^0.35 */
function segABC(t0: number, t1: number, W: number, H: number) {
  const pts: string[] = [];
  for (let i = 0; i <= 14; i++) {
    const t = t0 + ((t1 - t0) * i) / 14;
    pts.push(`${(t * W).toFixed(1)},${(H - Math.pow(t, 0.35) * H * 0.9).toFixed(1)}`);
  }
  const linha = pts.join(" ");
  const area = `${linha} ${(t1 * W).toFixed(1)},${H} ${(t0 * W).toFixed(1)},${H}`;
  return { linha, area };
}

export default function MockPainel() {
  const raiz = useRef<HTMLDivElement>(null);
  const [on, setOn] = useState(false);
  const [aba, setAba] = useState(0);
  const [manual, setManual] = useState(false);
  const [receita, setReceita] = useState(2_223_148.32);
  const [pagos, setPagos] = useState(7374);
  const [pedidosMapa, setPedidosMapa] = useState(7689);

  useEffect(() => {
    const el = raiz.current;
    if (!el) return;
    if (el.getBoundingClientRect().top < window.innerHeight) {
      setOn(true);
      return;
    }
    const io = new IntersectionObserver(
      ([e]) => e.isIntersecting && (setOn(true), io.disconnect()),
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!on) return;
    let vivo = true;
    let i = 0;
    const troca = manual
      ? null
      : setInterval(() => {
          if (!vivo) return;
          i = (i + 1) % CICLO.length;
          setAba(CICLO[i]);
        }, 7000);
    const caixa = setInterval(() => {
      if (!vivo) return;
      setReceita((r) => r + 120 + Math.random() * 480);
      if (Math.random() < 0.6) setPagos((p) => p + 1);
      if (Math.random() < 0.5) setPedidosMapa((p) => p + 1);
    }, 2400);
    return () => {
      vivo = false;
      if (troca) clearInterval(troca);
      clearInterval(caixa);
    };
  }, [on, manual]);

  const abc = {
    a: segABC(0, 0.2, 1000, 260),
    b: segABC(0.2, 0.5, 1000, 260),
    c: segABC(0.5, 1, 1000, 260),
  };

  return (
    <div ref={raiz} className="relative select-none overflow-hidden rounded-card bg-[#f2f2f0] text-[#333] shadow-[0_50px_110px_-50px_rgba(0,0,0,0.8)] [&_b]:font-semibold">
      {/* barra de abas */}
      <div className="flex items-center gap-2 overflow-x-auto bg-white px-3 py-2.5 shadow-[0_1px_4px_rgba(0,0,0,0.06)]">
        <span className="h-9 w-9 shrink-0 overflow-hidden rounded-md">
          <Image src="/brand/favicon_preto.svg" alt="Shoppub" width={36} height={36} className="h-full w-full" />
        </span>
        {ABAS.map((a, i) => (
          <button
            key={a.nome}
            type="button"
            onClick={() => a.viva && (setManual(true), setAba(i))}
            className={`flex shrink-0 items-center gap-2 whitespace-nowrap rounded-lg border px-3.5 py-2.5 text-[12.5px] font-semibold transition-colors ${
              aba === i
                ? "border-black bg-black text-white"
                : a.viva
                  ? "cursor-pointer border-[#dcdcd8] text-[#444] hover:border-[#444]"
                  : "border-[#e4e4e0] text-[#9a9a96]"
            }`}
          >
            <Icone d={a.icone} cls="h-4 w-4" stroke={aba === i ? "#fff" : a.viva ? "#444" : "#9a9a96"} />
            {a.nome}
          </button>
        ))}
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[#444]">›</span>
      </div>

      {/* corpo — altura fixa entre abas */}
      <div className="chat-scroll h-[640px] overflow-y-auto overscroll-contain p-4 lg:h-[620px] lg:overflow-hidden lg:overscroll-auto">
        {/* ============ GERAL ============ */}
        {aba === 0 && (
          <div key="geral" className="flex animate-[reveal-up_0.45s_cubic-bezier(0.22,1,0.36,1)] flex-col gap-3 lg:h-full">
            <div className="grid gap-3 lg:grid-cols-2">
              <Filtro icone="sacola" label="TODAS AS ORIGENS" />
              <Filtro icone="calendario" label="ESTE MÊS" />
            </div>
            <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
              <Kpi cor={VERMELHO} icone="pessoas" n="226.614" label="visitantes" delta="-3,2%" sobe={false} />
              <Kpi cor={AMARELO} icone="estrela" n="2.912 pedidos" label="de clientes novos" delta="+38,2%" sobe />
              <Kpi cor={VERDE} icone="carrinho" n="7.689" label="pedidos realizados" delta="+21,4%" sobe />
              <Kpi cor={AZUL} icone="ticket" n="R$ 289,00" label="ticket médio" delta="+5,6%" sobe />
            </div>
            <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
              <Kpi cor={VERMELHO} icone="cadastro" n="1.847" label="novos clientes cadastrados" delta="+25,8%" sobe />
              <Kpi cor={AMARELO} icone="recorrente" n="4.777 pedidos" label="de clientes recorrentes" delta="+17,3%" sobe />
              <Kpi cor={VERDE} icone="pct" n="3,40%" label="taxa de conversão" sub="(sem contabilizar marketplace)" delta="+11,6%" sobe />
              <Kpi cor={AZUL} icone="pct" n="3,12%" label="taxa de conversão real" sub="(sem contabilizar marketplace)" delta="+19,1%" sobe />
            </div>

            <div className="grid flex-1 gap-3 lg:grid-cols-2">
              <div className="flex flex-col justify-center rounded-lg bg-white p-5 text-center shadow-[0_1px_4px_rgba(0,0,0,0.07)]">
                <div className="text-[15px] font-semibold text-[#555]">Receita</div>
                <div className="mt-2 font-display text-[clamp(1.5rem,2.4vw,2.1rem)] font-semibold text-[#222]">
                  {fmt(receita)}{" "}
                  <span className="text-[13px] font-normal text-[#6f6f6f]">({pagos.toLocaleString("pt-BR")} pagos)</span>
                </div>
                <div className="mt-4 grid grid-cols-3 gap-2 text-left text-[10.5px] text-[#777]">
                  <div>
                    <span className="mr-1.5 inline-block h-2.5 w-2.5 rounded-[3px]" style={{ background: VERDE }} />
                    <b className="text-[#333]">R$ 2.223.148,32</b>
                    <span className="block pl-4">(total de pedidos: 7.689)</span>
                  </div>
                  <div>
                    <span className="mr-1.5 inline-block h-2.5 w-2.5 rounded-[3px]" style={{ background: AMARELO }} />
                    <b className="text-[#333]">R$ 41.220,00</b>
                    <span className="block pl-4">(87 em aberto)</span>
                  </div>
                  <div>
                    <span className="mr-1.5 inline-block h-2.5 w-2.5 rounded-[3px]" style={{ background: VERMELHO }} />
                    <b className="text-[#333]">R$ 96.480,00</b>
                    <span className="block pl-4">(228 cancelados)</span>
                  </div>
                </div>
              </div>
              <div className="rounded-lg bg-white p-5 shadow-[0_1px_4px_rgba(0,0,0,0.07)]">
                <div className="text-[15px] font-semibold text-[#555]">Pedidos por método:</div>
                <div className="mt-4 grid grid-cols-4 gap-2">
                  {[
                    { icone: "cadastro", n: "0", nome: "boleto", pagos: "0%", abertos: "0%", canc: "0%" },
                    { icone: "ticket", n: "3.152", nome: "cartão", pagos: "92%", abertos: "3%", canc: "5%" },
                    { icone: "grid", n: "4.399", nome: "Pix", pagos: "96%", abertos: "1%", canc: "3%" },
                    { icone: "cifrao", n: "138", nome: "Outros", pagos: "99%", abertos: "1%", canc: "0%" },
                  ].map((m) => (
                    <div key={m.nome} className="text-[10.5px] text-[#777]">
                      <div className="flex items-center gap-2">
                        <Icone d={m.icone} cls="h-5.5 w-5.5" stroke={VERDE_SP} />
                        <span><b className="block text-[12.5px] text-[#333]">{m.n}</b>{m.nome}</span>
                      </div>
                      <div className="mt-2 flex flex-col gap-1">
                        <span><span className="mr-1 inline-block h-2 w-2 rounded-[2px]" style={{ background: VERDE }} />{m.pagos} pagos</span>
                        <span><span className="mr-1 inline-block h-2 w-2 rounded-[2px]" style={{ background: AMARELO }} />{m.abertos} abertos</span>
                        <span><span className="mr-1 inline-block h-2 w-2 rounded-[2px]" style={{ background: VERMELHO }} />{m.canc} cancelados</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div>
              <div className="mb-2 text-[13px] font-semibold text-[#555]">Pedidos despachados e gastos com frete:</div>
              <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
                <Kpi cor={VERDE} icone="caminhao" n="7.212" label="pedidos despachados" delta="+22,7%" sobe />
                <Kpi cor={AMARELO} icone="cifrao" n="R$ 121.480,20" label="valor faturado" delta="+18,4%" sobe />
                <Kpi cor={VERMELHO} icone="pessoas" n="R$ 8.912,44 (7%)" label="frete pago pelo cliente" delta="+2,1%" sobe />
                <Kpi cor={AZUL} icone="check" n="R$ 16,85" label="valor médio de frete" delta="-9,3%" sobe />
              </div>
            </div>
          </div>
        )}

        {/* ============ MAPA DE VENDAS ============ */}
        {aba === 1 && (
          <div key="mapa" className="flex animate-[reveal-up_0.45s_cubic-bezier(0.22,1,0.36,1)] flex-col gap-3 lg:h-full">
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 rounded-lg bg-white px-4 py-3 text-[12px] shadow-[0_1px_4px_rgba(0,0,0,0.07)]">
              <span className="text-[#666]">Métricas:</span>
              <span className="rounded-md border border-[#dcdcd8] px-3 py-1.5 font-semibold text-[#444]">
                Porcentagem da quantidade total de pedidos ▾
              </span>
              <span className="text-[#666]">Data:</span>
              <span className="rounded-md border border-[#dcdcd8] px-3 py-1.5 font-semibold text-[#444]">Mês atual ▾</span>
              <span className="hidden items-center gap-2 text-[#666] lg:flex">
                <span className="h-4 w-4 rounded-[3px] border border-[#c8c8c4]" /> Exibir perfil de clientes no passar do mouse
              </span>
            </div>

            <div className="grid min-h-0 flex-1 gap-3 lg:grid-cols-[1fr_280px]">
              <div className="relative overflow-hidden rounded-lg bg-white p-2 shadow-[0_1px_4px_rgba(0,0,0,0.07)]">
                <svg viewBox={VIEWBOX} className="mx-auto h-[320px] w-auto lg:h-full" role="img" aria-label="Mapa nacional de pedidos por região">
                  {UFS_INFO.map((u) => (
                    <path key={u.uf} d={u.d} fill={REGIAO_COR[u.regiao]} stroke="#fff" strokeWidth="2.5" />
                  ))}
                  {UFS_INFO.filter((u) => PCT_UF[u.uf]).map((u) => (
                    <text key={u.uf} x={u.cx} y={u.cy} textAnchor="middle" fontSize="24" fontWeight="700" fill="#1e2b17">
                      {PCT_UF[u.uf]}
                    </text>
                  ))}
                </svg>
                {/* tooltip fiel ao produto */}
                <div className="absolute bottom-3 left-3 hidden w-[190px] rounded-lg bg-white p-3 shadow-[0_6px_24px_rgba(0,0,0,0.16)] sm:block">
                  <div className="text-center text-[12px] font-semibold text-[#333]">São Paulo</div>
                  <div className="mt-1.5 text-[10px] font-semibold text-[#2f9be4]">Top produtos vendidos</div>
                  {[["Blazer Linho Náutico", "412"], ["Tênis Knit X5 Cloud", "388"]].map(([n, v]) => (
                    <div key={n} className="flex justify-between text-[10px] text-[#666]"><span className="truncate pr-2">{n}</span><b>{v}</b></div>
                  ))}
                  <div className="mt-1.5 text-[10px] font-semibold text-[#2f9be4]">Top cidades</div>
                  {[["São Paulo", "1.204"], ["Campinas", "218"], ["Ribeirão Preto", "187"]].map(([n, v]) => (
                    <div key={n} className="flex justify-between text-[10px] text-[#666]"><span>{n}</span><b>{v}</b></div>
                  ))}
                </div>
              </div>

              <div className="chat-scroll overflow-y-auto rounded-lg bg-white p-4 shadow-[0_1px_4px_rgba(0,0,0,0.07)]">
                <div className="font-display text-lg font-semibold text-[#333]">Mapa Nacional</div>
                <div className="text-[11px] text-[#888]">Porcentagem da quantidade total de pedidos</div>
                <div className="mt-2 flex items-center gap-2 text-[12px] text-[#555]">
                  Total de pedidos neste mapa:
                  <span className="rounded-full px-2.5 py-0.5 text-[12px] font-semibold text-white" style={{ background: VERDE_SP }}>
                    {pedidosMapa.toLocaleString("pt-BR")}
                  </span>
                </div>
                <div className="mt-3 border-t border-[#eee] pt-2.5">
                  <div className="text-center text-[12px] font-semibold text-[#555] underline underline-offset-2">Regiões</div>
                  <div className="mt-2 flex flex-col gap-1.5">
                    {[
                      ["SE", "Sudeste", "54,07%"], ["S", "Sul", "15,79%"], ["NE", "Nordeste", "15,11%"],
                      ["CO", "Centro-oeste", "10,36%"], ["N", "Norte", "4,67%"],
                    ].map(([r, nome, pct]) => (
                      <div key={r} className="flex items-center gap-2.5 rounded-md bg-[#fafaf8] px-3 py-2 text-[12px]">
                        <span className="h-3 w-3 rounded-full" style={{ background: REGIAO_COR[r] }} />
                        <span className="font-semibold text-[#444]">{nome}</span>
                        <span className="ml-auto text-[#777]">{pct}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-3 border-t border-[#eee] pt-2.5">
                  <div className="text-center text-[12px] font-semibold text-[#555] underline underline-offset-2">Perfil geral de clientes</div>
                  <div className="mt-2 flex gap-1.5 text-[10px] font-semibold text-white">
                    <span className="flex-[78] rounded-md px-2 py-1.5" style={{ background: "#ec4899" }}>♀ 6,0k / 78%</span>
                    <span className="flex-[22] whitespace-nowrap rounded-md px-2 py-1.5" style={{ background: "#4aa8e0" }}>♂ 22%</span>
                  </div>
                  <div className="mt-2.5 flex items-end justify-between gap-1">
                    {[
                      ["15 a 24", 32, 8], ["25 a 35", 88, 22], ["34 a 45", 100, 28], ["44 a 55", 76, 20], ["54 a 65", 38, 10], ["65+", 16, 5],
                    ].map(([faixa, f, m]) => (
                      <div key={faixa as string} className="flex flex-col items-center gap-1">
                        <div className="flex items-end gap-[3px]">
                          <span className="w-[9px] rounded-t-sm" style={{ height: `${(f as number) * 0.5}px`, background: "#ec4899" }} />
                          <span className="w-[9px] rounded-t-sm" style={{ height: `${(m as number) * 0.5}px`, background: "#4aa8e0" }} />
                        </div>
                        <span className="text-[8.5px] font-semibold text-[#888]">{faixa}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ============ FLUXO DE VENDAS ============ */}
        {aba === 2 && (
          <div key="fluxo" className="flex animate-[reveal-up_0.45s_cubic-bezier(0.22,1,0.36,1)] flex-col gap-3 lg:h-full">
            <div className="grid gap-3 lg:grid-cols-2">
              <Filtro icone="sacola" label="TODAS AS ORIGENS" />
              <Filtro icone="calendario" label="15 DIAS" />
            </div>
            <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
              <Kpi cor={AZUL} icone="monitor" n="34%" label="desktop" />
              <Kpi cor={VERDE} icone="celular" n="66%" label="mobile" />
              <Kpi cor={AMARELO} icone="ticket" n="R$ 289,00" label="ticket médio" />
              <Kpi cor={VERMELHO} icone="carteira" n="R$ 1.112.480,15" label="receita total" />
            </div>
            <div className="grid min-h-0 flex-1 gap-3 lg:grid-cols-[1.5fr_1fr]">
              <div className="flex flex-col rounded-lg bg-white p-5 shadow-[0_1px_4px_rgba(0,0,0,0.07)]">
                <div className="text-[15px] font-semibold text-[#555]">Comportamento do cliente</div>
                <div className="mt-4 grid min-h-[190px] flex-1 grid-cols-4 gap-4 lg:min-h-0">
                  {[
                    ["Visitantes", "99.308", 100], ["Carrinhos ativos", "8.175", 16], ["Em checkout", "5.152", 12], ["Compras", "3.377", 9],
                  ].map(([nome, n, h]) => (
                    <div key={nome as string} className="flex min-h-0 flex-col border-l border-[#f0f0ee] pl-3 first:border-0 first:pl-0">
                      <div className="text-[13px] font-semibold text-[#333]">{nome}</div>
                      <div className="text-[15px] font-semibold text-[#333]">{n}</div>
                      <div className="mt-2 flex min-h-0 flex-1 items-end">
                        <div className="w-full rounded-t-md" style={{ height: `${h}%`, minHeight: 10, background: VERDE_SP, opacity: 0.85 }} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="chat-scroll overflow-y-auto rounded-lg bg-white p-4 shadow-[0_1px_4px_rgba(0,0,0,0.07)]">
                <div className="text-[14px] font-semibold text-[#555]">Produtos mais adicionados ao carrinho</div>
                <div className="mt-2 flex flex-col">
                  {[
                    ["Blazer Linho Náutico", "3010", "73 carrinhos", "587 itens", "21 convertidos", "28,8%"],
                    ["Tênis Knit X5 Cloud", "8825", "61 carrinhos", "412 itens", "19 convertidos", "31,1%"],
                    ["Camisa Winnie Movetech", "9952", "44 carrinhos", "207 itens", "12 convertidos", "27,3%"],
                    ["Mocassim Blair Cow Print", "9949", "21 carrinhos", "181 itens", "8 convertidos", "38,1%"],
                  ].map(([nome, sku, car, itens, conv, pct], i) => (
                    <div key={sku as string} className="flex items-start gap-2.5 border-b border-[#f0f0ee] py-2.5 last:border-0">
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-semibold text-white" style={{ background: AZUL }}>
                        {i + 1}
                      </span>
                      <span className="min-w-0 flex-1 text-[11px] text-[#777]">
                        <b className="block truncate text-[12px] text-[#333]">{nome}</b>
                        SKU: <b>{sku}</b> · {car} · {itens}
                      </span>
                      <span className="shrink-0 text-right text-[10.5px] text-[#777]">
                        {conv}
                        <b className="block text-[12px]" style={{ color: VERDE_SP }}>{pct}</b>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ============ PEDIDOS ============ */}
        {aba === 3 && (
          <div key="pedidos" className="flex animate-[reveal-up_0.45s_cubic-bezier(0.22,1,0.36,1)] flex-col gap-3 rounded-lg bg-white p-4 shadow-[0_1px_4px_rgba(0,0,0,0.07)] lg:h-full">
            {[
              {
                titulo: "Todos os pedidos",
                cels: [["291", "R$ 84.099,00", "R$ 288,99"], ["264", "R$ 76.296,00", "R$ 289,00"], ["7.689", "R$ 2.223.148,32", "R$ 289,13"], ["6.312", "R$ 1.824.168,00", "R$ 289,00"], ["61.204", "R$ 17.688.956,00", "R$ 289,02"]],
              },
              {
                titulo: "Pedidos pagos",
                cels: [["268", "R$ 77.452,00", "R$ 289,00"], ["243", "R$ 70.227,00", "R$ 289,00"], ["6.996", "R$ 2.022.064,00", "R$ 289,03"], ["5.744", "R$ 1.660.016,00", "R$ 289,00"], ["55.696", "R$ 16.096.144,00", "R$ 289,00"]],
              },
              {
                titulo: "Pedidos em aberto",
                cels: [["6", "R$ 2.843,00", "R$ 473,83"], ["4", "R$ 1.895,00", "R$ 473,75"], ["87", "R$ 41.220,00", "R$ 473,79"], ["63", "R$ 29.848,00", "R$ 473,78"], ["412", "R$ 195.201,00", "R$ 473,79"]],
              },
            ].map((sec) => (
              <div key={sec.titulo}>
                <div className="rounded-md bg-[#f4f4f2] px-4 py-2.5 text-[14px] font-semibold text-[#444]">{sec.titulo}</div>
                <div className="grid grid-cols-2 gap-3 px-4 pt-3 sm:grid-cols-3 lg:grid-cols-5 lg:gap-2">
                  {["Hoje", "Ontem", "Mês atual", "Mês anterior", "Lifetime"].map((p, i) => (
                    <div key={p} className="text-[11px] text-[#888]">
                      <div className="text-[13px] text-[#555]">{p}</div>
                      <div className="mt-1 text-[#333]"><b className="text-[14px]">{sec.cels[i][0]}</b> pedidos</div>
                      <div className="text-[13px] font-semibold" style={{ color: VERDE_SP }}>{sec.cels[i][1]}</div>
                      <div className="mt-0.5">Ticket Médio</div>
                      <div className="text-[12px] font-semibold" style={{ color: "#4aa8e0" }}>{sec.cels[i][2]}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ============ CURVA ABC ============ */}
        {aba === 4 && (
          <div key="abc" className="flex animate-[reveal-up_0.45s_cubic-bezier(0.22,1,0.36,1)] flex-col gap-3 lg:h-full">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className="text-[15px] font-semibold text-[#444]">
                Curva ABC das vendas dos produtos — Ordenado pelo faturamento
              </div>
              <div className="w-40"><Filtro icone="calendario" label="1 ANO" /></div>
            </div>

            <div className="rounded-lg bg-white p-4 shadow-[0_1px_4px_rgba(0,0,0,0.07)]">
              <div className="text-center text-[13px] font-semibold text-[#666]">Curva ABC de vendas</div>
              <svg viewBox="0 0 1000 260" className="mt-1 w-full" preserveAspectRatio="none" style={{ height: 130 }}>
                <polygon points={abc.a.area} fill="#8bc34a" opacity="0.85" />
                <polygon points={abc.b.area} fill="#29b6f6" opacity="0.8" />
                <polygon points={abc.c.area} fill="#fbc02d" opacity="0.8" />
                <polyline points={`${abc.a.linha} ${abc.b.linha} ${abc.c.linha}`} fill="none" stroke="#555" strokeWidth="2" opacity="0.35" />
              </svg>
              <div className="mt-1.5 flex items-center justify-center gap-5 text-[11px] font-semibold text-[#555]">
                <span><span className="mr-1.5 inline-block h-2.5 w-2.5 rounded-full" style={{ background: "#8bc34a" }} />Curva A</span>
                <span><span className="mr-1.5 inline-block h-2.5 w-2.5 rounded-full" style={{ background: "#29b6f6" }} />Curva B</span>
                <span><span className="mr-1.5 inline-block h-2.5 w-2.5 rounded-full" style={{ background: "#fbc02d" }} />Curva C</span>
              </div>
            </div>

            <span className="w-fit rounded-md px-3 py-1.5 text-[11px] font-semibold text-white" style={{ background: "#29b6f6" }}>
              ⓘ Duplo clique no nome para ir para o produto
            </span>

            <div className="grid min-h-0 flex-1 grid-cols-1 gap-3 lg:grid-cols-3">
              {[
                {
                  cor: "#8bc34a", titulo: "Curva A - 20% dos produtos",
                  bullets: ["54,1% do volume total de vendas (11.848)", "69,2% do faturamento total (R$ 1.537.856)"],
                  itens: [["Blazer Linho Náutico", "R$ 212.400,00"], ["Tênis Knit X5 Cloud", "R$ 187.950,00"], ["Camisa Winnie Movetech", "R$ 141.310,00"]],
                },
                {
                  cor: "#29b6f6", titulo: "Curva B - 30% dos produtos",
                  bullets: ["22,0% do volume total de vendas (4.808)", "26,2% do faturamento total (R$ 582.465)"],
                  itens: [["Legging Doreen Basic Fit", "R$ 38.907,80"], ["Top Alana Basic Fit", "R$ 36.845,45"], ["Mocassim Blair Cow Print", "R$ 35.998,37"]],
                },
                {
                  cor: "#fbc02d", titulo: "Curva C - 50% dos produtos",
                  bullets: ["23,9% do volume total de vendas (5.239)", "4,6% do faturamento total (R$ 102.827)"],
                  itens: [["Porta Celular Shelter Íris", "R$ 8.175,00"], ["Cinto Casual em Couro", "R$ 7.978,55"], ["Porta Note em Couro Preto", "R$ 7.451,09"]],
                },
              ].map((c) => (
                <div key={c.titulo} className="flex min-h-0 flex-col overflow-hidden rounded-lg bg-white shadow-[0_1px_4px_rgba(0,0,0,0.07)]">
                  <div className="px-3 py-2 text-center text-[12.5px] font-semibold text-white" style={{ background: c.cor }}>
                    {c.titulo}
                  </div>
                  <div className="flex flex-col gap-1 px-3.5 pt-2.5 text-[10.5px] text-[#666]">
                    {c.bullets.map((b) => (
                      <span key={b}><span className="mr-1.5 inline-block h-1.5 w-1.5 rounded-full" style={{ background: c.cor }} />{b}</span>
                    ))}
                  </div>
                  <div className="mx-3.5 mt-2 flex justify-between border-b border-[#eee] bg-[#fafaf8] px-2 py-1.5 text-[10px] font-semibold text-[#888]">
                    <span>nome</span><span>faturamento</span>
                  </div>
                  <div className="px-3.5 pb-3">
                    {c.itens.map(([n, v]) => (
                      <div key={n} className="flex items-center justify-between border-b border-[#f2f2f0] py-1.5 text-[11px] last:border-0">
                        <span className="truncate pr-2 text-[#555]">{n}</span>
                        <span className="flex shrink-0 items-center gap-1.5 font-semibold text-[#333]">
                          {v}
                          <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill={c.cor}><path d="M12 5C6 5 2 12 2 12s4 7 10 7 10-7 10-7-4-7-10-7zm0 10a3 3 0 110-6 3 3 0 010 6z" /></svg>
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* sino de notificações flutuante */}
      <span className="absolute bottom-4 right-4 flex h-11 w-11 items-center justify-center rounded-full bg-[#1c1c20] shadow-lg">
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 16v-5a6 6 0 10-12 0v5l-1.5 2h15zM10 20a2 2 0 004 0" />
        </svg>
        <span className="absolute -right-0.5 -top-0.5 flex h-4.5 min-w-4.5 items-center justify-center rounded-full bg-[#c62f2c] px-1 text-[9px] font-semibold text-white">
          10
        </span>
      </span>
    </div>
  );
}
